export default __webpack_public_path__ + "static/media/about-hero-img.4223448d.svg";